import { render, staticRenderFns } from "./consult-info26.vue?vue&type=template&id=f67aa29e&scoped=true"
import script from "./consult-info26.vue?vue&type=script&lang=js"
export * from "./consult-info26.vue?vue&type=script&lang=js"
import style0 from "./consult-info26.vue?vue&type=style&index=0&id=f67aa29e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67aa29e",
  null
  
)

export default component.exports